import { Model } from '@vuex-orm/core'
import shortid from 'shortid'
import _ from 'lodash'
import ContactAddress from './ContactAddress';
import ContactPhone from './ContactPhone';
import RequestContact from './RequestContact';
import moment from 'moment'
import store from '../store';

export default class Contact extends Model {
    static entity = 'contacts'
    static fields() {
        return {
            id: this.attr("tmp/" + shortid.generate()),
            zepplinId: this.attr(null),
            name: this.attr(null),
            companyId: this.attr(null),
            obs: this.attr(null),
            contactGroupId: this.attr(null),
            origin: this.attr(null),
            legalDocument: this.attr(null),
            dateUpdated: this.attr(null),
            dateCreated: this.attr(moment().toISOString()),
            dateRemoved: this.attr(null),
            status: this.attr('active'),
            contactAddresses: this.hasMany(ContactAddress, 'contactId'),
            contactPhones: this.hasMany(ContactPhone, 'contactId'),
            contactRequestContacts: this.hasMany(RequestContact, 'contactId'),
        }
    }

    deleteAllInContact() {
        const vm = this
        if(_.result(vm, 'contactPhones')) 
            vm.contactPhones.forEach(contactPhone => contactPhone.$delete({ where: contactPhone.id }))
        if(_.result(vm, 'contactAddresses'))
            vm.contactAddresses.forEach(contactAddress => {
                if(contactAddress.address && contactAddress.address.addressContactAddresses.length <= 1)
                    contactAddress.address.$delete({ where: contactAddress.addressId })
                contactAddress.$delete({ where: contactAddress.id })
            })
        vm.$delete()
        
    }

    static beforeCreate(model) {
        if(!model.companyId) model.companyId = store.state.auth.user.defaultCompanyId
    }

}